"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const decorators_1 = require("../../../../common/decorators");
const qrcode_react_1 = __importDefault(require("qrcode.react"));
const HandoverSlideWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background: ${props => `linear-gradient(41.42deg, rgba(0, 0, 0, 0.651) 1.11%, rgba(0, 0, 0, 0.318) 66.33%, rgba(255, 255, 255, 0.0001) 132.88%),
    ${props.theme.palette.mainAppColor.main}`};
  color: white;
`;
const ContentContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70%;
  height: 50%;

  @media (orientation: portrait) {
    gap: 3vmin;
    flex-direction: column;
    padding: 2vmin 0;
  }
`;
const DevicesWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 40%;

  img {
    width: 90%;
    height: 100%;
    object-fit: contain;
    aspect-ratio: 3 / 1;
  }

  @media (orientation: portrait) {
    flex: 1;
    width: 100%;
  }
`;
const TitleAndAdvantages = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 2vmin;
  gap: 1vmin;

  @media (orientation: portrait) {
    order: 2;
  }

  .qr-code {
    border-radius: 5px;
    border: 2px solid white;
    box-shadow: 0 0 0 5px black;
    margin: 10px;
  }
`;
const Title = styled_components_1.default.p `
  display: flex;
  align-items: center;
  font-size: clamp(20px, calc(1.5rem + (42 - 20) * ((100vw - 768px) / (1920 - 768))), 42px);
  min-height: 0vw;
  margin: 0;
`;
const Advantages = styled_components_1.default.ul `
  font-size: clamp(16px, calc(1rem + (30 - 16) * ((100vw - 768px) / (1920 - 768))), 30px);
  min-height: 0vw;
  margin: 0;
  padding-left: 3vmin !important;

  li {
    list-style-type: disc !important;
  }
`;
const HandoverSlide = ({ deepLink, brandInfo }) => {
    const isPartOfTuiBlueBrands = !!brandInfo.brand.slug.includes('tui-blue');
    return (react_1.default.createElement(HandoverSlideWrapper, null,
        react_1.default.createElement(ContentContainer, null,
            react_1.default.createElement(TitleAndAdvantages, null,
                react_1.default.createElement(Title, null, i18n_js_1.default.t('ds_download_app_title', {
                    appName: isPartOfTuiBlueBrands ? 'BLUE' : brandInfo.brand.name,
                })),
                react_1.default.createElement(Advantages, null,
                    react_1.default.createElement("li", null,
                        " ",
                        i18n_js_1.default.t('ds_advantage_hotel_info')),
                    react_1.default.createElement("li", null, isPartOfTuiBlueBrands ? i18n_js_1.default.t('ds_advantage_program_tui_blue') : i18n_js_1.default.t('ds_advantage_program')),
                    react_1.default.createElement("li", null,
                        " ",
                        i18n_js_1.default.t('ds_advantage_registration'),
                        " "),
                    react_1.default.createElement("li", null, isPartOfTuiBlueBrands
                        ? i18n_js_1.default.t('ds_advantage_downloadable_tui_blue')
                        : i18n_js_1.default.t('ds_advantage_downloadable'))),
                deepLink && react_1.default.createElement(qrcode_react_1.default, { value: deepLink, size: 100, className: "qr-code" })),
            react_1.default.createElement(DevicesWrapper, null,
                react_1.default.createElement("img", { src: "/images/other/portrait.png", alt: "Mockup", className: `mockup-image ` })))));
};
const mapStoreToProps = store => ({
    brandInfo: store.getValue('brandInfo'),
    deepLink: store.getValue('deeplink'),
});
exports.default = (0, decorators_1.withStore)(mapStoreToProps)(HandoverSlide);
